jQuery(document).ready(function($){
    
    // Resource filter - keep original redirect behavior
    $('.resource-filter').on('change', function () {
        var url = $(this).val();
        if (url && url.trim() !== '' && url !== '0') {
            window.location.href = url;
        }
        return false;
    });

    // Event filter - use AJAX for template-all-events page
    // Check if we're on a page with AJAX-enabled filters
    var isAjaxEnabled = false;
    
    // Check multiple ways to determine if AJAX should be used
    if (typeof eventsFiltersAjax !== 'undefined') {
        isAjaxEnabled = true;
    } else if ($('.resource-filters[data-ajax-enabled="true"]').length > 0) {
        isAjaxEnabled = true;
    } else if ($('.event-filter[data-ajax-filter="true"]').length > 0) {
        isAjaxEnabled = true;
    }
    
    if (isAjaxEnabled) {
        // Ensure eventsFiltersAjax is defined (fallback)
        if (typeof eventsFiltersAjax === 'undefined') {
            window.eventsFiltersAjax = {
                ajaxurl: ajax_global ? ajax_global.url : '/wp-admin/admin-ajax.php',
                nonce: ajax_global ? ajax_global.nonce : '',
                page_url: window.location.href
            };
        }
        
        // CRITICAL: Prevent any form submission that might contain our filters
        $(document).on('submit', 'form', function(e) {
            if ($(this).find('.event-filter[data-ajax-filter="true"]').length > 0) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                return false;
            }
        });
        
        // CRITICAL: Use immediate binding on page load, before any other handlers
        var $eventFilters = $('.event-filter[data-ajax-filter="true"]');
        
        if ($eventFilters.length === 0) {
            // Try without the data attribute requirement - maybe they're not loaded yet
            $eventFilters = $('.event-filter');
            // Add the data attribute if missing
            $eventFilters.attr('data-ajax-filter', 'true');
        }
        
        // Define loadEventsAjax function FIRST so it's available
        var loadEventsAjax = function(eventType, eventDate, page) {
            // Check if eventsFiltersAjax is defined
            if (typeof eventsFiltersAjax === 'undefined') {
                alert('AJAX configuration not found. Please refresh the page.');
                return;
            }
            
            // Show loading state
            var $container = $('.featured-events .container');
            var $eventsContainer = $container.find('.events-list-container');
            
            // If events container doesn't exist, create it
            if ($eventsContainer.length === 0) {
                $eventsContainer = $('<div class="events-list-container"></div>');
                $container.append($eventsContainer);
            }
            
            // Store current content height to prevent layout shift
            var currentHeight = $eventsContainer.height();
            if (currentHeight < 300) currentHeight = 300;
            
            // Create loading overlay with circular spinner
            var $loadingOverlay = $('<div class="events-loading-overlay" style="min-height: ' + currentHeight + 'px;"><div class="events-loading-spinner"><div class="spinner-circle"></div><p>Loading, pls wait...</p></div></div>');
            
            // Set container to relative positioning if not already
            $eventsContainer.css({
                'position': 'relative',
                'min-height': currentHeight + 'px'
            });
            
            // Remove any existing loading overlay
            $eventsContainer.find('.events-loading-overlay').remove();
            
            // Add loading overlay
            $eventsContainer.append($loadingOverlay);
            
            // Disable filters during loading
            $('.event-filter').prop('disabled', true);
            
            // Prepare AJAX data
            var ajaxData = {
                action: 'filter_events',
                nonce: eventsFiltersAjax.nonce,
                event_type: eventType,
                event_date: eventDate,
                paged: page
            };
            
            // Make AJAX request
            $.ajax({
                url: eventsFiltersAjax.ajaxurl,
                type: 'POST',
                data: ajaxData,
                success: function(response) {
                    // Add 1 second delay before showing content
                    setTimeout(function() {
                        // Remove loading overlay
                        $loadingOverlay.fadeOut(200, function() {
                            $(this).remove();
                        });
                        
                        // Re-enable filters
                        $('.event-filter').prop('disabled', false);
                        
                        if (response && response.success && response.data) {
                            // Update events HTML
                            $eventsContainer.html(response.data.html);
                            
                            // Reset container height
                            $eventsContainer.css('min-height', 'auto');
                        
                        // Update pagination
                        var $paginationSection = $('.pagination');
                        if (response.data.pagination) {
                            if ($paginationSection.length) {
                                $paginationSection.find('.events-pagination-wrapper').replaceWith(response.data.pagination);
                            } else {
                                // Create pagination section if it doesn't exist
                                $paginationSection = $('<section class="pagination pt-small pb-medium"><div class="container"><div class="row justify-content-center"><div class="col-12 text-center"></div></div></div></section>');
                                $('.featured-events').append($paginationSection);
                                $paginationSection.find('.col-12').html(response.data.pagination);
                            }
                            $paginationSection.show();
                        } else {
                            $paginationSection.hide();
                        }
                        
                        // Update month header if date filter is active
                        var $container = $('.featured-events .container');
                        var $monthHeader = $container.find('.event-month');
                        if (eventDate) {
                            if ($monthHeader.length) {
                                $monthHeader.find('h2').text(eventDate + ' Events');
                            } else {
                                $eventsContainer.before('<div class="row"><div class="col-12 event-month"><h2>' + eventDate + ' Events</h2><hr></div></div>');
                            }
                        } else {
                            $monthHeader.remove();
                        }
                        
                        // Update URL without reload
                        updateURL(eventType, eventDate, page);
                        
                            // Scroll to top of events section smoothly
                            var $featuredEvents = $('.featured-events');
                            if ($featuredEvents.length) {
                                $('html, body').animate({
                                    scrollTop: $featuredEvents.offset().top - 100
                                }, 300);
                            }
                        } else {
                            // Show error message
                            $eventsContainer.html('<div class="row"><div class="col-12 text-center"><p class="text-danger">Error loading events. Please try again.</p></div></div>');
                            $eventsContainer.css('min-height', 'auto');
                        }
                    }, 1000); // 1 second delay
                },
                error: function(xhr, status, error) {
                    // Add 1 second delay before showing error
                    setTimeout(function() {
                        // Remove loading overlay
                        $loadingOverlay.fadeOut(200, function() {
                            $(this).remove();
                        });
                        
                        // Re-enable filters
                        $('.event-filter').prop('disabled', false);
                        
                        // Reset container height
                        $eventsContainer.css('min-height', 'auto');
                        
                        // Show error message
                        var errorMsg = 'Error loading events. Please try again.';
                        if (xhr.responseJSON && xhr.responseJSON.data && xhr.responseJSON.data.message) {
                            errorMsg = xhr.responseJSON.data.message;
                        } else if (xhr.responseText) {
                            try {
                                var errorData = JSON.parse(xhr.responseText);
                                if (errorData.data && errorData.data.message) {
                                    errorMsg = errorData.data.message;
                                }
                            } catch(e) {
                                // Could not parse error response
                            }
                        }
                        $eventsContainer.html('<div class="row"><div class="col-12 text-center"><p class="text-danger">' + errorMsg + '</p><p><small>Status: ' + xhr.status + ' | Error: ' + error + '</small></p></div></div>');
                    }, 1000); // 1 second delay
                }
            });
        };
        
        // Bind directly to elements first (highest priority)
        $eventFilters.each(function() {
            var $select = $(this);
            
            // Remove ALL existing handlers including namespaced ones
            $select.off('change change.ajaxFilter');
            
            // Bind our handler with highest priority
            $select.on('change.ajaxFilter', function (e) {
                // Prevent default navigation
                e.preventDefault();
                
                // Also prevent on the original event
                if (e.originalEvent) {
                    e.originalEvent.preventDefault();
                }
                
                // Prevent any potential navigation
                if (window.event) {
                    window.event.preventDefault();
                }
                
                // Stop any timers that might cause navigation
                clearTimeout(window._ajaxNavigationTimeout);
                
                // Now stop propagation after we've processed
                e.stopPropagation();
                e.stopImmediatePropagation();
            
                var $select = $(this);
                var selectId = $select.attr('id');
            
                // Get current filter values
                var eventType = '';
                var eventDate = '';
                // Always reset to page 1 when filter changes
                var currentPage = 1;
            
                if (selectId === 'event-type') {
                    // Get the selected option data attribute or value
                    var selectedOption = $select.find('option:selected');
                    eventType = selectedOption.data('post-type') || selectedOption.val() || '';
                    
                    // Reset date filter when type changes
                    $('#event-date').val('all');
                } else if (selectId === 'event-date') {
                    // Get event-type from the other select
                    var $typeSelect = $('#event-type');
                    var selectedTypeOption = $typeSelect.find('option:selected');
                    eventType = selectedTypeOption.data('post-type') || selectedTypeOption.val() || '';
                    
                    // Get selected date from data attribute or value
                    var selectedOption = $select.find('option:selected');
                    eventDate = selectedOption.data('month') || '';
                    
                    // If "All Events" is selected, clear the date filter
                    if (selectedOption.val() === 'all' || selectedOption.val() === '') {
                        eventDate = '';
                    }
                }
                
                // Load events via AJAX (always start from page 1 when filter changes)
                loadEventsAjax(eventType, eventDate, currentPage);
                
                // Return false to prevent any default behavior
                return false;
            });
        });
        
        // Also use event delegation as backup with namespace
        $(document).off('change.ajaxFilterDelegate', '.event-filter[data-ajax-filter="true"]');
        $(document).on('change.ajaxFilterDelegate', '.event-filter[data-ajax-filter="true"]', function(e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
        });
        
        // Prevent any click events that might trigger navigation
        $(document).on('click', '.event-filter[data-ajax-filter="true"]', function(e) {
            e.stopPropagation();
        });
        
        // Prevent any mousedown that might trigger navigation
        $(document).on('mousedown', '.event-filter[data-ajax-filter="true"]', function(e) {
            if (e.which === 1) { // Left click
                e.stopPropagation();
            }
        });
        
        // Handle Clear Filters button
        $(document).off('click', '#clear-filters-btn').on('click', '#clear-filters-btn', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Reset both filter selects to default values
            $('#event-type').val('');
            $('#event-date').val('all');
            
            // Load events with no filters, page 1
            loadEventsAjax('', '', 1);
            
            return false;
        });
        
        // Handle pagination links with AJAX
        $(document).off('click', '.ajax-pagination-link').on('click', '.ajax-pagination-link', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            var page = $(this).data('page') || 1;
            
            // Get current filter values from URL or selects
            var urlParams = new URLSearchParams(window.location.search);
            var eventType = urlParams.get('event-type') || '';
            var eventDate = urlParams.get('event-date') || '';
            
            // If not in URL, get from selects
            if (!eventType) {
                var $typeSelect = $('#event-type');
                var selectedTypeOption = $typeSelect.find('option:selected');
                eventType = selectedTypeOption.data('post-type') || selectedTypeOption.val() || '';
            }
            if (!eventDate) {
                var $dateSelect = $('#event-date');
                var selectedDateOption = $dateSelect.find('option:selected');
                eventDate = selectedDateOption.data('month') || '';
                if (selectedDateOption.val() === 'all' || selectedDateOption.val() === '') {
                    eventDate = '';
                }
            }
            
            // Load events via AJAX
            loadEventsAjax(eventType, eventDate, page);
            
            return false;
        });
        
        // loadEventsAjax is now defined above, before the event handler
        
        /**
         * Update URL without page reload
         */
        function updateURL(eventType, eventDate, page) {
            var url = new URL(window.location.href);
            
            // Remove existing params
            url.searchParams.delete('event-type');
            url.searchParams.delete('event-date');
            url.searchParams.delete('paged');
            
            // Add new params
            if (eventType) {
                url.searchParams.set('event-type', eventType);
            }
            if (eventDate) {
                url.searchParams.set('event-date', eventDate);
            }
            if (page > 1) {
                url.searchParams.set('paged', page);
            }
            
            // Update URL without reload
            window.history.pushState({eventType: eventType, eventDate: eventDate, page: page}, '', url.toString());
        }
        
        // Handle browser back/forward buttons
        window.addEventListener('popstate', function(event) {
            if (event.state) {
                loadEventsAjax(event.state.eventType || '', event.state.eventDate || '', event.state.page || 1);
            } else {
                // Get from URL params
                var urlParams = new URLSearchParams(window.location.search);
                var eventType = urlParams.get('event-type') || '';
                var eventDate = urlParams.get('event-date') || '';
                var page = parseInt(urlParams.get('paged')) || 1;
                loadEventsAjax(eventType, eventDate, page);
            }
        });
        
        // Initialize: If page loads with filters, ensure dropdowns are set correctly
        var urlParams = new URLSearchParams(window.location.search);
        var urlEventType = urlParams.get('event-type') || '';
        var urlEventDate = urlParams.get('event-date') || '';
        
        // Set event-type dropdown if URL has it
        if (urlEventType) {
            $('#event-type option[data-post-type="' + urlEventType + '"]').prop('selected', true);
        }
        
        // Set event-date dropdown if URL has it
        if (urlEventDate) {
            $('#event-date option[data-month="' + urlEventDate + '"]').prop('selected', true);
        }
    } else {
        // Fallback: If AJAX is not available, use redirect behavior
        $('.event-filter').on('change', function () {
            var url = $(this).val();
            if (url && url.trim() !== '' && url !== '0') {
                window.location.href = url;
            }
            return false;
        });
    }
});
